// for react-dropzone lib
// 使用時以一個wrapper function將預設的accpetedFiles, rejectedFiles
// 以及ownerThis傳入
// owner必須有對應的states

import React from 'react';

import MaskLink from './MaskLink';
import RemoveIcon from './RemoveIcon';
import { PreviewImgWithDnd, PreviewPDFWithDnd, PreviewVideoWithDnd } from './FilePreviewPs';

import searchContent from '../commonJS/searchContent';
import getSort from '../commonJS/getSort';


export function onFileDrop(accpetedFiles, rejectedFiles, ownerThis, isDownload, singleFileLimit, enableDnd, fileSorts, parentStateHandler, containerThis) {
  // React docs says: Treat ownerThis.state as if it were immutable.
  let uploadedFiles = [],
    uploadedImgs = [],
    uploadedPDFs = [],
    uploadedVideos = [],
    previewsImg = [],
    previewsPDF = [],
    previewsVideo = [],
    thumbnail = 'preview',
    preview = 'preview',
    fileName = 'name';
  // upload與download是不同元件管理，所以名稱相同無影響
  // 為download使用的情況下，為了易讀性，將名稱改為download
  // 並以換內容不換皮的方式處理程式碼
  if (isDownload) {
    // download之前上傳的需求只有1次，不需累積
    uploadedFiles = accpetedFiles;
    // uploadedImgs = ownerThis.state.downloadedImgs.slice();
    // uploadedPDFs = ownerThis.state.downloadedPDFs.slice();
    // uploadedVideos = ownerThis.state.downloadedVideos.slice();
    thumbnail = 'thumbnail'
    preview = 'file_name';
    fileName = 'file_name'
  } else {

    // ownerThis.props.uploadFiles不是父元件的state，
    // 只是一個父元件的資料陣列參照，可以直接改
    if (singleFileLimit) {
      ownerThis.props.uploadedFiles[0] = accpetedFiles[0];
    } else {
      ownerThis.props.uploadedFiles.push(...accpetedFiles);
    }

    uploadedImgs = ownerThis.state.uploadedImgs.slice();
    uploadedPDFs = ownerThis.state.uploadedPDFs.slice();
    uploadedVideos = ownerThis.state.uploadedVideos.slice();
  }

  const len = accpetedFiles.length;

  // 分類
  for (let i = 0; i < len; i++) {
    const fileNameValue = accpetedFiles[i][fileName];
    switch (accpetedFiles[i].type) {
      case 'image/jpeg':
      case 'image/png':
      case 'image/svg+xml':
        if (singleFileLimit) uploadedImgs[0] = accpetedFiles[0];
        else uploadedImgs.push(accpetedFiles[i]);
        // 記錄排序
        if (fileSorts) {
          if (isDownload) {
            fileSorts.img.push(fileNameValue);
          } else {
            fileSorts.img.unshift(fileNameValue);
          }
        }
        break;
      case 'application/pdf':
        if (singleFileLimit) uploadedPDFs[0] = accpetedFiles[0];
        else uploadedPDFs.push(accpetedFiles[i]);
        if (fileSorts) {
          if (isDownload) {
            fileSorts.pdf.push(fileNameValue);
          } else {
            fileSorts.pdf.unshift(fileNameValue);
          }
        }
        break;
      case 'video/mp4':
        if (singleFileLimit) uploadedVideos[0] = accpetedFiles[0];
        else uploadedVideos.push(accpetedFiles[i]);
        if (fileSorts) {
          if (isDownload) {
            fileSorts.video.push(fileNameValue);
          } else {
            fileSorts.video.unshift(fileNameValue);
          }
        }
        break;
      default:
    }
  }

  // 產生預覽(優化tip:只更新新增的部份)
  // 暫時disable
  if (0) {
    previewsImg = uploadedImgs.map(
      (item, ind) => {
        return (
          <figure key={ind}>
            <img src={item[thumbnail]} alt="thumbnail" />
            {/*<figcaption>{item.name || item.file_name}</figcaption>*/}

            <MaskLink href={item[preview]} />

            <RemoveIcon onFileDelete={e => { e.stopPropagation(); ownerThis.onFileDelete('img', item[fileName]); }} />
          </figure>
        );
      }
    );
  }

  previewsImg = uploadedImgs.map(
    (item, ind) => {
      return <PreviewImgWithDnd
        enableDnd={enableDnd}
        key={isDownload ? ('d' + ind) : ind}
        // sort={fileSorts ? getSort(fileSorts.img, item[fileName]) : ""}
        fileSort={fileSorts ? fileSorts.img : ""}
        parentStateHandler={parentStateHandler}
        src={item[thumbnail]}
        fileType='img'
        href={item[preview]}
        ownerThis={ownerThis}
        containerThis={isDownload ? ownerThis : containerThis} // download的情況下owner就是container
        fileName={item[fileName]} />;
    }
  );

  if (0) {
    previewsPDF = uploadedPDFs.map(
      (item, ind) => {
        return (
          <span key={isDownload ? ('d' + ind) : ind} className='span-pdf-container'>
            <span className='span-embed-scrollbar-cutter'>
              <embed
                src={item[preview]}
                type="application/pdf" />
            </span>

            <MaskLink href={item[preview]} />

            <RemoveIcon onFileDelete={e => { e.stopPropagation(); ownerThis.onFileDelete('pdf', item[fileName]); }} />
          </span>
        );
      }
    );
  }

  previewsPDF = uploadedPDFs.map(
    (item, ind) => {
      return <PreviewPDFWithDnd
        enableDnd={enableDnd}
        key={isDownload ? ('d' + ind) : ind}
        // sort={fileSorts ? getSort(fileSorts.img, item[fileName]) : ""}
        fileSort={fileSorts ? fileSorts.pdf : ""}
        parentStateHandler={parentStateHandler}
        src={isDownload ? item[thumbnail] : ''}
        showName={isDownload ? '' : item[fileName]}
        fileType='pdf'
        href={item[preview]}
        ownerThis={ownerThis}
        containerThis={isDownload ? ownerThis : containerThis} // download的情況下owner就是container
        fileName={item[fileName]} />;
    }
  );

  if (0) {
    previewsVideo = uploadedVideos.map(
      (item, ind) => {
        return (
          <span key={isDownload ? ('d' + ind) : ind} className='span-video-container'>
            <video controls onClick={e => { e.stopPropagation(); }}>
              <source src={item[preview]} type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            <RemoveIcon onFileDelete={e => { e.stopPropagation(); ownerThis.onFileDelete('video', item[fileName]); }} />
          </span>
        );
      }
    );
  }

  previewsVideo = uploadedVideos.map(
    (item, ind) => {
      return <PreviewVideoWithDnd
        enableDnd={enableDnd}
        key={isDownload ? ('d' + ind) : ind}
        // sort={fileSorts ? getSort(fileSorts.img, item[fileName]) : ""}
        fileSort={fileSorts ? fileSorts.video : ""}
        parentStateHandler={parentStateHandler}
        src={isDownload ? item[thumbnail] : ''}
        showName={isDownload ? '' : true}
        fileType='video'
        href={item[preview]}
        ownerThis={ownerThis}
        containerThis={isDownload ? ownerThis : containerThis} // download的情況下owner就是container
        fileName={item[fileName]} />;
    }
  );

  if (isDownload) {
    ownerThis.setState({
      downloadedFiles: uploadedFiles,
      downloadedImgs: uploadedImgs,
      downloadedPDFs: uploadedPDFs,
      downloadedVideos: uploadedVideos,
      deletedDownloadedFiles: [], // 重置
      previewsImg, previewsPDF, previewsVideo
    });
  } else {
    ownerThis.setState({ uploadedImgs, uploadedPDFs, uploadedVideos, previewsImg, previewsPDF, previewsVideo });
  }

};


export function onFileDelete(type, fileName, ownerThis, isDownload, fileSorts) {
  let indOfItem = "",
    loadedImgs = 'uploadedImgs',
    loadedPDFs = 'uploadedPDFs',
    loadedVideos = 'uploadedVideos',
    keyToSearch = 'name',
    deletedDownloadedFiles = [];

  if (isDownload) {
    loadedImgs = 'downloadedImgs';
    loadedPDFs = 'downloadedPDFs';
    loadedVideos = 'downloadedVideos';
    keyToSearch = 'file_name';
    deletedDownloadedFiles = ownerThis.state.deletedDownloadedFiles.slice();
  }

  // 從內部upload files與preview中移除
  switch (type) {
    case 'img':
      let uploadedImgs = ownerThis.state[loadedImgs].slice(),
        previewsImg = ownerThis.state.previewsImg.slice();

      indOfItem = searchContent([fileName], uploadedImgs, [keyToSearch], 1);

      uploadedImgs.splice(indOfItem[0], 1);
      previewsImg.splice(indOfItem[0], 1);
      ownerThis.setState({ [loadedImgs]: uploadedImgs, previewsImg });
      // 從排序控制arr中移除
      if (fileSorts) fileSorts.img.splice(getSort(fileSorts.img, fileName), 1);
      break;
    case 'pdf':
      let uploadedPDFs = ownerThis.state[loadedPDFs].slice(),
        previewsPDF = ownerThis.state.previewsPDF.slice();

      indOfItem = searchContent([fileName], uploadedPDFs, [keyToSearch], 1);

      uploadedPDFs.splice(indOfItem[0], 1);
      previewsPDF.splice(indOfItem[0], 1);
      ownerThis.setState({ [loadedPDFs]: uploadedPDFs, previewsPDF });

      if (fileSorts) fileSorts.pdf.splice(getSort(fileSorts.pdf, fileName), 1);
      break;
    case 'video':
      let uploadedVideos = ownerThis.state[loadedVideos].slice(),
        previewsVideo = ownerThis.state.previewsVideo.slice();

      indOfItem = searchContent([fileName], uploadedVideos, [keyToSearch], 1);

      uploadedVideos.splice(indOfItem[0], 1);
      previewsVideo.splice(indOfItem[0], 1);
      ownerThis.setState({ [loadedVideos]: uploadedVideos, previewsVideo });

      if (fileSorts) fileSorts.video.splice(getSort(fileSorts.video, fileName), 1);
      break;
    default:
  }
  // 從parent upload files 中移除

  indOfItem = searchContent([fileName], ownerThis[isDownload ? 'state' : 'props'][isDownload ? 'downloadedFiles' : 'uploadedFiles'], [keyToSearch], 1);

  if (isDownload) {
    let downloadedFiles = ownerThis.state.downloadedFiles.slice();
    // 記錄被刪除的檔案
    const deletedItem = downloadedFiles.splice(indOfItem[0], 1);
    deletedDownloadedFiles.push(deletedItem[0]);
    ownerThis.setState({ downloadedFiles, deletedDownloadedFiles });
  } else {
    ownerThis.props.uploadedFiles.splice(indOfItem[0], 1);
  }

}

export function onFileDrop2(accpetedFiles, rejectedFiles, ownerThis, isDownload, singleFileLimit, previews) {

  // React docs says: Treat ownerThis.state as if it were immutable.
  let uploadedFiles = [],
    uploadedImgs = [],
    uploadedPDFs = [],
    uploadedVideos = [],
    previewsImg = [],
    previewsPDF = [],
    previewsVideo = [],
    thumbnail = 'preview',
    preview = 'preview',
    fileName = 'name';
  // upload與download是不同元件管理，所以名稱相同無影響
  // 為download使用的情況下，為了易讀性，將名稱改為download
  // 並以換內容不換皮的方式處理程式碼
  if (isDownload) {
    // download之前上傳的需求只有1次，不需累積
    uploadedFiles = accpetedFiles;
    // uploadedImgs = ownerThis.state.downloadedImgs.slice();
    // uploadedPDFs = ownerThis.state.downloadedPDFs.slice();
    // uploadedVideos = ownerThis.state.downloadedVideos.slice();
    thumbnail = 'thumbnail'
    preview = 'file_name';
    fileName = 'file_name'
  } else {

    // ownerThis.props.uploadFiles不是父元件的state，
    // 只是一個父元件的資料陣列參照，可以直接改
    if (singleFileLimit) {
      ownerThis.props.uploadedFiles[0] = accpetedFiles[0];
    } else {
      ownerThis.props.uploadedFiles.push(...accpetedFiles);
    }

    uploadedImgs = ownerThis.state.uploadedImgs.slice();
    uploadedPDFs = ownerThis.state.uploadedPDFs.slice();
    uploadedVideos = ownerThis.state.uploadedVideos.slice();
  }

  const len = accpetedFiles.length;

  // 分類
  for (let i = 0; i < len; i++) {
    switch (accpetedFiles[i].type) {
      case 'image/jpeg':
      case 'image/png':
      case 'image/svg+xml':
        if (singleFileLimit) uploadedImgs[0] = accpetedFiles[0];
        else uploadedImgs.push(accpetedFiles[i]);

        break;
      case 'application/pdf':
        if (singleFileLimit) uploadedPDFs[0] = accpetedFiles[0];
        else uploadedPDFs.push(accpetedFiles[i]);
        break;
      case 'video/mp4':
        if (singleFileLimit) uploadedVideos[0] = accpetedFiles[0];
        else uploadedVideos.push(accpetedFiles[i]);
        break;
      default:
    }
  }

  // 產生預覽(優化tip:只更新新增的部份)
  previewsImg = uploadedImgs.map(
    (item, ind) => {
      return (
        <figure key={isDownload ? ('d' + ind) : ind}>
          <img src={item[thumbnail]} alt="thumbnail" />
          {/*<figcaption>{item.name || item.file_name}</figcaption>*/}

          <MaskLink href={item[preview]} />

          <RemoveIcon onFileDelete={e => { e.stopPropagation(); ownerThis.onFileDelete('img', item[fileName], previews); }} />
        </figure>
      );
    }
  );

  previewsPDF = uploadedPDFs.map(
    (item, ind) => {
      return (
        <span key={isDownload ? ('d' + ind) : ind} className='span-pdf-container'>
          <span className='span-embed-scrollbar-cutter'>
            <embed
              src={item[preview]}
              type="application/pdf" />
          </span>

          <MaskLink href={item[preview]} />

          <RemoveIcon onFileDelete={e => { e.stopPropagation(); ownerThis.onFileDelete('pdf', item[fileName], previews); }} />
        </span>
      );
    }
  );

  previewsVideo = uploadedVideos.map(
    (item, ind) => {
      return (
        <span key={isDownload ? ('d' + ind) : ind} className='span-video-container'>
          <video controls onClick={e => { e.stopPropagation(); }}>
            <source src={item[preview]} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          <RemoveIcon onFileDelete={e => { e.stopPropagation(); ownerThis.onFileDelete('video', item[fileName], previews); }} />
        </span>
      );
    }
  );

  if (isDownload) {

    if (previews === 'repair_preview') {
      ownerThis.setState({
        repair_preview: { previewsImg, previewsPDF, previewsVideo },
        repair_downloadedFiles: uploadedFiles,
        repair_downloadedImgs: uploadedImgs,
        repair_downloadedPDFs: uploadedPDFs,
        repair_downloadedVideos: uploadedVideos,
        delete_repair_files: []
      })
    }
    else if (previews === 'maintain_preview') {
      ownerThis.setState({
        maintain_preview: { previewsImg, previewsPDF, previewsVideo },
        maintain_downloadedFiles: uploadedFiles,
        maintain_downloadedImgs: uploadedImgs,
        maintain_downloadedPDFs: uploadedPDFs,
        maintain_downloadedVideos: uploadedVideos,
        delete_maintain_files: []
      })
    }
  } else {
    ownerThis.setState({ uploadedImgs, uploadedPDFs, uploadedVideos, previewsImg, previewsPDF, previewsVideo });
  }

};


export function onFileDelete2(type, fileName, ownerThis, isDownload, previews) {

  const { previewsImg, previewsPDF, previewsVideo } = ownerThis.state[previews]

  let indOfItem = "",
    loadedImgs = 'uploadedImgs',
    loadedPDFs = 'uploadedPDFs',
    loadedVideos = 'uploadedVideos',
    keyToSearch = 'name',
    deletedDownloadedFiles = [],
    downloaded_files = '',
    delete_files = '';

  if (isDownload) {

    if (previews === 'repair_preview') {
      loadedImgs = 'repair_downloadedImgs';
      loadedPDFs = 'repair_downloadedPDFs';
      loadedVideos = 'repair_downloadedVideos';
      delete_files = 'delete_repair_files'
      downloaded_files = 'repair_downloadedFiles'
    }
    else if (previews === 'maintain_preview') {
      loadedImgs = 'maintain_downloadedImgs';
      loadedPDFs = 'maintain_downloadedPDFs';
      loadedVideos = 'maintain_downloadedVideos';
      keyToSearch = 'file_name';
      downloaded_files = 'maintain_downloadedFiles';
      delete_files = 'delete_maintain_files'
    }
    keyToSearch = 'file_name';
    deletedDownloadedFiles = ownerThis.state[delete_files].slice();
  }

  // 從內部upload files與preview中移除
  switch (type) {
    case 'img':
      let uploadedImgs = ownerThis.state[loadedImgs].slice(),
        previews_img = ownerThis.state[previews].previewsImg.slice();

      indOfItem = searchContent([fileName], uploadedImgs, [keyToSearch], 1);

      uploadedImgs.splice(indOfItem[0], 1);
      previews_img.splice(indOfItem[0], 1);
      ownerThis.setState({ [loadedImgs]: uploadedImgs, [previews]: { previewsImg: previews_img, previewsPDF, previewsVideo } });
      break;
    case 'pdf':
      let uploadedPDFs = ownerThis.state[loadedPDFs].slice(),
        previews_pdf = ownerThis.state[previews].previewsPDF.slice();

      indOfItem = searchContent([fileName], uploadedPDFs, [keyToSearch], 1);

      uploadedPDFs.splice(indOfItem[0], 1);
      previews_pdf.splice(indOfItem[0], 1);
      ownerThis.setState({ [loadedPDFs]: uploadedPDFs, [previews]: { previewsImg, previewsPDF: previews_pdf, previewsVideo } });
      break;
    case 'video':
      let uploadedVideos = ownerThis.state[loadedVideos].slice(),
        previews_video = ownerThis.state[previews].previewsVideo.slice();

      indOfItem = searchContent([fileName], uploadedVideos, [keyToSearch], 1);

      uploadedVideos.splice(indOfItem[0], 1);
      previews_video.splice(indOfItem[0], 1);
      ownerThis.setState({ [loadedVideos]: uploadedVideos, [previews]: { previewsImg, previewsPDF, previewsVideo: previews_video } });
      break;
    default:
  }
  // 從parent upload files 中移除

  indOfItem = searchContent([fileName], ownerThis[isDownload ? 'state' : 'props'][isDownload ? downloaded_files : 'uploadedFiles'], [keyToSearch], 1);

  if (isDownload) {
    let downloadedFiles = ownerThis.state[downloaded_files].slice();
    // 記錄被刪除的檔案
    const deletedItem = downloadedFiles.splice(indOfItem[0], 1);
    deletedDownloadedFiles.push(deletedItem[0]);
    ownerThis.setState({ [downloaded_files]: downloadedFiles, [delete_files]: deletedDownloadedFiles });
  } else {
    ownerThis.props.uploadedFiles.splice(indOfItem[0], 1);
  }

}

export default { onFileDrop, onFileDelete, onFileDrop2, onFileDelete2 };


// WEBPACK FOOTER //
// ./src/commonComponents/onFileModify.jsx